import {useState} from 'react';
import {Box, InputAdornment, Typography} from '@mui/material';
import TextField from '@jobseeker/lotus/elements/Input';
import Dialog from '@jobseeker/lotus/components/Dialog';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {Image} from '@jobseeker/lotus/components/Image';
import {SearchIcon} from '@jobseeker/lotus/icons';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

interface MobileSelectDialogV1Props {
  open: boolean;
  onClose: () => void;
  title: string;
  options: {label: string; value: string | number}[];
  subtitle?: string;
  allowSearch?: boolean;
  label?: string;
  onChange: any;
  value?: any;
}

const MobileSelectDialogV1: React.FC<MobileSelectDialogV1Props> = ({
  open,
  onClose,
  title,
  options,
  subtitle,
  allowSearch = false,
  label,
  onChange,
  value,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredOptions = allowSearch
    ? options.filter(option =>
        option.label.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : options;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      invertedTitle={false}
      variant={VersionVariants.VERSION_SEVEN}
      subtitle={subtitle}
    >
      {allowSearch ? (
        <Box>
          <Box paddingLeft={'16px'} paddingRight={'16px'} paddingTop={'16px'}>
            <TextField
              fullWidth
              placeholder={`${label}`}
              value={searchQuery}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Image
                      src={SearchIcon}
                      alt="search"
                      width={16}
                      height={16}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                '.MuiInputBase-input': {
                  border: 'unset !important',
                  fontSize: '12px !important',
                  paddingLeft: 0,
                  py: '13px',
                },
                '.MuiInputBase-input::placeholder': {
                  fontSize: '12px',
                  fontWeight: 400,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                  opacity: 0.8,
                },
                mb: '8px',
              }}
              onChange={e => setSearchQuery(e.target.value)}
              // sx={{
              //   mb: 2,
              //   '& .MuiOutlinedInput-root': {
              //     borderRadius: '8px',
              //   },
              // }}
              onKeyDown={e => {
                if (e.key !== 'Escape') {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
              variant={VersionVariants.VERSION_TWO}
            />
          </Box>
          <Box sx={{height: '400px', maxHeight: '400px', overflowY: 'auto'}}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map(option => (
                <Box
                  key={option.value}
                  onClick={() => {
                    onChange(option.value);
                    onClose();
                    setSearchQuery('');
                  }}
                  sx={{
                    paddingLeft: '16px',
                    paddingBottom: '11px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    paddingTop: '11px',
                    backgroundColor:
                      option.value == value
                        ? isAppIimjobs
                          ? '#91B87929'
                          : 'rgba(233, 99, 12, 0.08)'
                        : 'white',
                    // '&:hover': {
                    //   backgroundColor: '#91B87929',
                    // },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                    }}
                  >
                    {option.label}
                  </Typography>
                </Box>
              ))
            ) : (
              <Box sx={{height: '400px'}}>
                <Typography
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    color: '#7E7E7E',
                    fontSize: '12px',
                    fontWeight: 400,
                    opacity: 1,
                    mt: 1,
                    paddingLeft: '16px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                  }}
                >
                  No results found
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{maxHeight: '400px', overflowY: 'auto', paddingBottom: '16px'}}
        >
          {options.map(option => (
            <Box
              key={option.value}
              onClick={() => {
                onChange(option.value);
                onClose();
              }}
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                cursor: 'pointer',
                transition: 'background 0.2s',
                backgroundColor:
                  option.value == value
                    ? isAppIimjobs
                      ? '#91B87929'
                      : 'rgba(233, 99, 12, 0.08)'
                    : 'white',
                paddingLeft: '16px',
                paddingTop: '8px',
                paddingBottom: '8px',
                // '&:hover': {
                //   backgroundColor: '#91B87929',
                // },
              }}
            >
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 400,
                }}
              >
                {option.label}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Dialog>
  );
};

export default MobileSelectDialogV1;
